import ServicePageShell from "@/components/site/ServicePageShell";
export default function SantePrevoyance() { return <ServicePageShell slug="sante-prevoyance" />; }
